import adminClasses from "../../../landing-pages/admin/admin.module.css";
import { useForm } from "react-hook-form";
import PrimarySkillRequestModel from "../../../../models/admin/skill/request/PrimarySkillRequestModel";
import { OBJECT_NAME_RULE, OBJECT_DESCRIPTION_RULE } from "../../../../utils/validation-utils";
import toasterUtils from "../../../../utils/toaster-utils";
import { Button, FormControl, TextField } from "@mui/material";

interface PrimarySkillProps {
    objPrimarySkill: PrimarySkillRequestModel;
    actionType: string;
    onClosePrimarySkill: () => void;
    onPrimarySkillSave: (objPrimarySkill: PrimarySkillRequestModel) => void;
}

const PrimarySkillCreateComponent = (props: PrimarySkillProps) => {
    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<PrimarySkillRequestModel>({
        mode: "onChange",
        defaultValues: props.objPrimarySkill
    });

    const onSubmit = (formData: PrimarySkillRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onPrimarySkillSave(formData);
    }

    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.primarySkillName}>
                                <TextField label="Primary Skill Name" size="small"
                                    {...register("primarySkillName", OBJECT_NAME_RULE)} error={!!errors.primarySkillName} helperText={errors.primarySkillName?.message} autoComplete="off" required />
                            </FormControl>
                        </div>
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.description}>
                                <TextField label="Description" size="small" multiline rows={3}
                                    {...register("description", OBJECT_DESCRIPTION_RULE)} error={!!errors.description} helperText={errors.description?.message} autoComplete="off" />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                Save
                            </Button>
                            <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onClosePrimarySkill}>
                                Close
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default PrimarySkillCreateComponent;